import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Handshake, Sparkles } from "lucide-react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const stageColors = {
  contacto: "bg-slate-100 text-slate-700",
  evaluacion: "bg-blue-100 text-blue-700",
  confidencialidad: "bg-indigo-100 text-indigo-700",
  propuesta: "bg-amber-100 text-amber-700",
  negociacion: "bg-purple-100 text-purple-700",
  acuerdo: "bg-yellow-100 text-yellow-700",
  ejecucion: "bg-emerald-100 text-emerald-700",
  reporte: "bg-cyan-100 text-cyan-700",
  cierre: "bg-slate-100 text-slate-500",
};

export default function RoomsList() {
  const { t, i18n } = useTranslation();
  const dateLocale = i18n.language === "en" ? "en-US" : i18n.language === "pt" ? "pt-BR" : "es-ES";
  const [rooms, setRooms] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/api/rooms");
      setRooms(data);
    })();
  }, []);

  return (
    <DashboardLayout
      title={t("rooms_list.title")}
      subtitle={t("rooms_list.subtitle")}
    >
      {rooms.length === 0 ? (
        <div className="kpi-card p-10 text-center">
          <Handshake size={28} className="text-gold mx-auto" />
          <h3 className="font-display text-2xl text-petroleum mt-3">{t("rooms_list.empty_title")}</h3>
          <p className="text-slate-500 mt-2">{t("rooms_list.empty_desc")}</p>
        </div>
      ) : (
        <div className="grid gap-4">
          {rooms.map((r) => (
            <Link
              key={r.id}
              to={`/dashboard/negociaciones/${r.id}`}
              data-testid={`room-${r.id}`}
              className="kpi-card p-5 flex items-start justify-between gap-6 hover:border-gold/40 transition-colors"
            >
              <div className="flex-1">
                <div className="flex items-center gap-3 flex-wrap">
                  <h3 className="font-display text-2xl text-petroleum">{r.title}</h3>
                  <Badge className={`${stageColors[r.stage]} hover:${stageColors[r.stage]}`}>{t(`room.stage_${r.stage}`)}</Badge>
                  {r.agreement?.status === "signed" && (
                    <Badge className="bg-emerald-600 text-white hover:bg-emerald-600">{t("rooms_list.agreement_signed")}</Badge>
                  )}
                </div>
                <p className="text-sm text-slate-500 mt-2">{t("rooms_list.with_prefix", { name: r.counterparty?.name || t("rooms_list.counterparty_default") })}</p>
                <div className="mt-3 flex items-center gap-4 text-xs text-slate-500">
                  <span>{t("rooms_list.milestones_count", { count: r.milestones?.length || 0 })}</span>
                  <span>{t("rooms_list.nda_progress", { signed: r.nda?.signatures?.length || 0, total: r.participants?.length || 2 })}</span>
                  <span>{t("rooms_list.updated_at", { date: new Date(r.updated_at).toLocaleDateString(dateLocale) })}</span>
                </div>
              </div>
              <Sparkles size={16} className="text-gold shrink-0 mt-2" />
            </Link>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
